











































import Assinatura from "@/shared/components/assinatura.vue";
import DataTable from "@/shared/components/data-table.vue";
import Planos from "@/shared/components/tabela-planos.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import ConsultorSelecionado from "../components/ConsultorSelecionado.vue";
import Atendimentos from "../tables/Atendimentos.vue";
import EnviosAutomaticos from "../tables/EnviosAutomaticos.vue";
import Tickets from "../tables/Tickets.vue";
import UltimosAcessos from "../tables/UltimosAcessos.vue";

@Component({
  components: {
    DataTable,
    Assinatura,
    UltimosAcessos,
    Planos,
    Atendimentos,
    Tickets,
    ConsultorSelecionado,
    EnviosAutomaticos,
  },
})
export default class TabIndex extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;

  loadingEnvios = false;

  public atualizarConsultorSelecionado() {
    const consultorSelecionado = this.$refs
      .consultorSelecionado as ConsultorSelecionado;
    consultorSelecionado.atualizarConsultorSelecionado();

    const assinatura = this.$refs.assinatura as Assinatura;
    assinatura.fetchAssinatura(this.idConsultor);

    const planos = this.$refs.planos as Planos;
    planos.fetchPlanos(this.idConsultor);
    planos.fetchConsultoresSelecionado(this.idConsultor);
  }
}
